import { CSSProperties, HTMLAttributes } from 'react';
import { css } from '@emotion/react';
import { InfoHoverIcon } from '@frontend/analytics-shared';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { TruncatedText } from '../../truncated-text';

export type StatItemData = {
  infoHoverText?: string;
  label?: string;
  labelStyle?: CSSProperties;
  value?: number | string;
};

export type StatItemProps = StatItemData & {
  subAlignment?: 'bottom' | 'right';
  valueFontSize?: number | string;
} & HTMLAttributes<HTMLDivElement>;

export const StatItem = ({
  infoHoverText,
  label,
  labelStyle = {},
  subAlignment = 'right',
  value = 0,
  valueFontSize = theme.font.size.h1,
  ...rest
}: StatItemProps) => {
  return (
    <div className={subAlignment} css={styles.wrapper} {...rest}>
      <Text as='span' className='value' textAlign='left' weight='bold' style={{ fontSize: valueFontSize }}>
        {value}
      </Text>
      <div css={styles.labelWithTip}>
        <TruncatedText
          as='span'
          className='label'
          style={{ color: theme.colors.neutral50, ...labelStyle }}
          text={label}
          textAlign='left'
        />
        {infoHoverText && <InfoHoverIcon text={infoHoverText} />}
      </div>
    </div>
  );
};

const styles = {
  labelWithTip: css`
    align-items: center;
    display: flex;
    gap: ${theme.spacing(1)};
    justify-content: flex-start;
    min-width: 0; // Required to correctly truncate the text
  `,

  wrapper: css`
    max-width: 100%;

    &.right {
      align-items: baseline;
      display: flex;
      gap: ${theme.spacing(2)};
    }

    span {
      display: block;
    }

    .value {
      line-height: 1;
    }
  `,
};
